// extracted by mini-css-extract-plugin
export default {"subTitle":"Subtitle_subTitle__G20Me"};